import { useMemo, useEffect } from "react";
import { Box, Button, Tooltip, Badge } from "@material-ui/core";
import { useLazyQuery } from "@apollo/client";
import { GET_PERSON_RELATIONSHIPS_LENGTH } from "../../Queries/GetPersonRelationshipsLength";

const PersonDetailButtons = ({
  inIncident,
  onlineState,
  locked,
  personId,
  addPersonClick,
  removePersonClick,
  searchClick,
  historyClick,
  relationshipClick,
  startIncident,
  user,
  knownAssociatesNumber,
}) => {
  const [getRelationshipsLength, { data: relationshipData }] = useLazyQuery(
    GET_PERSON_RELATIONSHIPS_LENGTH,
    {
      context: { serializationKey: "incidentQueue" },
      variables: { personId: personId, originatorId: user?.id },
      onError: error => {
        console.error(JSON.stringify(error));
      },
    }
  );

  useEffect(() => {
    if (!!personId && !personId.includes("Offline")) {
      getRelationshipsLength();
    }
  }, [getRelationshipsLength, personId]);

  const noHistory = !personId || personId.includes("Offline");

  const relationshipsNumber = useMemo(() => {
    if (relationshipData) {
      const nonEmptyRelationships = relationshipData[
        Object.keys(relationshipData)[0]
      ]?.relationships.filter(rel => !!rel?.person);
      return nonEmptyRelationships?.length;
    } else {
      return null;
    }
  }, [relationshipData]);

  const handleRemovePerson = () => {
    removePersonClick();
  };

  const handleSearchOpen = () => {
    searchClick(true);
  };
  const handleHistoryOpen = () => {
    historyClick(true);
  };
  const handleRelationshipOpen = () => {
    relationshipClick(true);
  };

  const handleStartIncident = () => {
    startIncident(personId);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
      style={{ width: "100%" }}
    >
      {inIncident && (
        <Button
          style={{
            width: "fit-content",
            marginTop: "1vh",
            marginBottom: "3vh",
            marginRight: "2vw",
          }}
          disabled={locked}
          variant="contained"
          onClick={handleRemovePerson}
        >
          Delete Person
        </Button>
      )}
      {inIncident && (
        <Button
          style={{
            width: "fit-content",
            marginTop: "1vh",
            marginBottom: "3vh",
            marginRight: "2vw",
          }}
          disabled={locked}
          variant="contained"
          onClick={addPersonClick}
        >
          Add Person
        </Button>
      )}
      <Button
        disabled={!onlineState && import.meta.env.VITE_FORCE_ONLINE !== "true"}
        style={{
          width: "fit-content",
          marginTop: "1vh",
          marginBottom: "3vh",
          marginRight: "2vw",
        }}
        variant="contained"
        onClick={handleSearchOpen}
      >
        Search
      </Button>
      <WrappedButton
        title="Person History"
        clickHandler={handleHistoryOpen}
        badgeContent={knownAssociatesNumber}
        onlineState={onlineState}
        showCount={false}
        disabled={noHistory}
      />
      <WrappedButton
        title="Relationships"
        clickHandler={handleRelationshipOpen}
        badgeContent={relationshipsNumber}
        onlineState={onlineState}
        showCount={true}
        disabled={noHistory}
      />
      {/* <Button disabled={!onlineState && import.meta.env.VITE_FORCE_ONLINE !== 'true'} style={{ width: "fit-content", marginTop: '1vh', marginBottom: '3vh', marginRight: "2vw" }} variant="contained" onClick={handleRelationshipOpen}>Relationships</Button> */}
      {!inIncident && (
        <Tooltip title="Creates New Incident with Selected Person Attached">
          <Button
            disabled={
              !onlineState && import.meta.env.VITE_FORCE_ONLINE !== "true"
            }
            style={{
              width: "fit-content",
              marginTop: "1vh",
              marginBottom: "3vh",
              marginRight: "2vw",
            }}
            variant="contained"
            onClick={handleStartIncident}
          >
            Start Incident
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};

const WrappedButton = ({
  badgeContent,
  showCount = true,
  clickHandler,
  onlineState,
  title,
  disabled,
}) => {
  return (
    <span style={{ marginTop: "1vh", marginBottom: "3vh", marginRight: "2vw" }}>
      <Badge
        color="primary"
        variant={!showCount ? "dot" : "standard"}
        invisible={
          badgeContent === undefined ||
          badgeContent === null ||
          badgeContent === 0 ||
          badgeContent === ""
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        badgeContent={showCount && badgeContent}
        showZero={false}
        overlap="rectangular"
      >
        <Button
          disabled={
            (!onlineState && import.meta.env.VITE_FORCE_ONLINE !== "true") ||
            disabled
          }
          style={{ width: "fit-content" }}
          variant="contained"
          onClick={clickHandler}
        >
          {title}
        </Button>
      </Badge>
    </span>
  );
};
export default PersonDetailButtons;
